import React, { useEffect } from "react";
import Button from "../../Common/FormElements/Button/Button";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import { toast } from "react-toastify";
import { getErrorPayMessage } from "../../../Utils";

const PayementFail = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const specificParam = urlParams.get("Erreur");
    if (specificParam) {
      toast.error(getErrorPayMessage(specificParam));
    }
  }, []);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center">
      <img src="payement-fail.jpg" className="w25 mb-4" alt="Echec payement" />
      <h2>{t("Payment failed !")}</h2>
      <div className="mt-5 d-flex flex-column gap-2">
        <p className="text-center">
          {t("Sorry, an error occurred while processing your payment.")}
          <br />
          {t("Please check your payment details and try again.")}
        </p>
      </div>
      <Button className="mt-5" onClick={() => navigate("/catalogue")}>
        {t("Back to catalogue")}
      </Button>
    </div>
  );
};

export default PayementFail;
